export enum TransactionJournalCode {
  ANouveaux = 'AN',
  Achats = 'AC',
  Banque = 'BQ',
  Caisse = 'CA',
  OperationsDiverses = 'OD',
  Ventes = 'VT',
}
